module.exports = __webpack_public_path__ + "files/f3a30fd11b4f31d5b405a52bb18942ae.png";